import React, { ReactElement } from 'react'
import { format } from 'date-fns'
import styles from './CalendarNavigation.css'

type OnNavigationButtonClick = () => void;
interface CalendarNavigationProps extends CalendarNavigationBaseProps {
  focusedDay: Date;
  selectPrevious: OnNavigationButtonClick;
  selectNext: OnNavigationButtonClick;
  toggleCalendarFormat: OnNavigationButtonClick
}

interface CustomNavigationRendererProps {
  selectPrevious: () => void
  selectNext: () => void
  toggleCalendarFormat: () => void
}

type CustomNavigationRenderer = ({selectNext, selectPrevious }: CustomNavigationRendererProps) => ReactElement

export interface CalendarNavigationBaseProps {
  renderNavigation?: CustomNavigationRenderer,
}

const CalendarNavigation = ({
  focusedDay,
  selectPrevious,
  selectNext,
  renderNavigation,
  toggleCalendarFormat,
}: CalendarNavigationProps) => {
  if (renderNavigation) {
    return renderNavigation({selectNext, selectPrevious, toggleCalendarFormat})
  }

  return (
    <div className={styles.calendarNavigation}>
      <button type='button' onClick={selectPrevious}>prev M</button>
      <button type='button'>{format(focusedDay, 'yyyy LLLL')}</button>
      <button type='button' onClick={selectNext}>next M</button>
    </div>
  )
}

export default CalendarNavigation
